<body #body class="isOpen">
  <nav #sidebar class="sidebar">
      <header class="p-2">
          <div class="image-fgc">
              <span class="image">
                  <img src="../../../../assets/logos/fgc-logo.svg" alt="">
              </span>
              <div class="text">
                  <div class="text-header">
                      <span class="name">Bem vindo(a)</span>
                      <span class="usuario">{{usuario}}</span>
                  </div>
              </div>
            </div>
          <i data-testid="botao-esconder-menu" #toggle (mouseup)="removeClose()" class="fas fa-bars toggle ml-4"></i>
      </header>

      <div class="menu-bar p-2  ">
        <div class="menu mt-4">
          <ul class="menu-links mb-5">
            <!-- <li #search class="search-box">
                <i class="fas fa-search icon"></i>
                <input list="sistemas" type="text" placeholder="Search..." class="text nav-text">
                <datalist id="sistemas">
                  <option ><a href="censo"> Pesquisar Envio Censo </a></option>
                  <option value="1">Pesquisar If Sem Envio</option>
                  <option value="1">Pesquisar Contribuições</option>
                  <option value="1">Pesquisar Conciliação</option>
                  <option value="1">Pesquisar Importação b3</option>
                  <option value="1">Pesquisar Parâmetros</option>
                  <option value="1">Pesquisar Taxa Selic</option>
                  <option value="1">Pesquisar Taxa Selic Diaria</option>
                </datalist>
            </li> -->
            <li *ngFor="let item of menuItems" class="mt-4">
              <a data-testid="botoes-menus" (click)="goToDetail(item.urlPath)" >
                <i [class]="item.icon"></i>
                <span class="text nav-text">{{item.nameItem}}</span>
              </a>
            </li>
          </ul>
          <div class="bottom-content pt-5">
            <li class="">
              <a data-testid="botao-logout" class="exitButton" (click)="resetStorage()">
                <i class="fas fa-sign-out-alt icon"></i>
                <span class="text nav-text">Sair</span>
              </a>
            </li>
          </div>
        </div>
      </div>
  </nav>

<div class="container-fluid px-5 py-3">
  <ng-content></ng-content>
  </div>
</body>

